import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import { __decorate } from "tslib";
import { Component, Vue } from "../../../vue";
const valTypes = ['string', 'number', 'boolean', 'object', 'array'];
let SchemaBaseView = class SchemaBaseView extends Vue {
  constructor() {
    super(...arguments);
    this.mode = 'edit';
    this.itemsType = valTypes[0];
  }
  get schema() {
    return {};
  }
  get isHasId() {
    return true; // any 避免自动变成属性
  }

  get isItems() {
    return false; // any 避免自动变成属性
  }

  get title() {
    return this.options.title || '创建字段';
  }
  get isShowItemType() {
    return true;
  }
  get itemSelectTypes() {
    return valTypes.filter(id => id !== 'array');
  }
  get isEdit() {
    return this.mode === 'edit';
  }
  onSave() {}
  onKeyUp(e) {
    if (e.key !== 'Enter') {
      return;
    }
    this.onSave();
  }
  mounted() {
    window.addEventListener('keyup', this.onKeyUp);
  }
  beforeDestroy() {
    window.removeEventListener('keyup', this.onKeyUp);
  }
  get formItems() {
    const getDisabled = key => {
      var _this$options$disable, _this$options$disable2;
      return (_this$options$disable = (_this$options$disable2 = this.options.disabledFields) === null || _this$options$disable2 === void 0 ? void 0 : _this$options$disable2.includes(key)) !== null && _this$options$disable !== void 0 ? _this$options$disable : false;
    };
    return [...(this.isHasId ? [{
      key: 'id',
      label: '字段索引',
      disabled: getDisabled('id')
    }] : []), {
      key: 'type',
      label: '字段类型',
      disabled: getDisabled('type'),
      isSelect: true,
      items: valTypes
    }, ...(this.isItems ? [] : [{
      key: 'title',
      label: '字段中文名',
      disabled: getDisabled('title'),
      autoFocus: this.isEdit
    }, {
      key: 'desc',
      label: '字段描述',
      disabled: getDisabled('desc')
    }])];
  }
  get isArray() {
    return this.schema.type === 'array';
  }
  get formComponent() {
    return this.$refs.form;
  }
  get rules() {
    const required = {
      required: true,
      message: '必填项',
      trigger: ['change', 'blur']
    };
    return {
      id: [required, {
        validator: (_rule, value, callback) => {
          const reg = /^[\w]+$/;
          if (!reg.test(value)) {
            callback(new Error('只允许输入字母、数字、下划线三种字符'));
          } else {
            callback();
          }
        },
        trigger: ['change', 'blur']
      }],
      type: [required]
    };
  }
  async validateForm() {
    try {
      await this.formComponent.validate();
      return true;
    } catch (error) {
      return false;
    }
  }
  renderForm() {
    const h = this.$createElement;
    return h("a-modal", {
      "attrs": {
        "title": this.title,
        "visible": true,
        "cancelText": "取消",
        "okText": "保存 (Enter)"
      },
      "class": '',
      "on": {
        "cancel": this.onCancel,
        "ok": this.onSave
      }
    }, [h("a-form-model", _mergeJSXProps([{
      "ref": "form"
    }, {
      "props": {
        model: this.schema
      }
    }, {
      "attrs": {
        "rules": this.rules
      }
    }]), [this.formItems.map(info => h("a-form-model-item", {
      "key": info.key,
      "attrs": {
        "has-feedback": true,
        "label": info.label,
        "prop": info.key
      }
    }, [info.isSelect ? h("a-select", {
      "attrs": {
        "disabled": info.disabled,
        "placeholder": `请选择${info.label}`,
        "autoFocus": info.autoFocus
      },
      "model": {
        value: this.schema[info.key],
        callback: $$v => {
          this.$set(this.schema, info.key, $$v);
        }
      }
    }, [info.items.map(k => h("a-select-option", {
      "attrs": {
        "value": k
      }
    }, [k]))]) : h("a-input", {
      "attrs": {
        "autocomplete": "off",
        "disabled": info.disabled,
        "autoFocus": info.autoFocus,
        "placeholder": `请输入${info.label}`
      },
      "model": {
        value: this.schema[info.key],
        callback: $$v => {
          this.$set(this.schema, info.key, typeof $$v === "string" ? $$v.trim() : $$v);
        }
      }
    })])), this.isArray && this.isShowItemType && h("a-form-model-item", {
      "key": 'items',
      "attrs": {
        "has-feedback": true,
        "label": '数组类型'
      }
    }, [h("a-select", {
      "attrs": {
        "disabled": false,
        "placeholder": '请选择数组类型'
      },
      "model": {
        value: this.itemsType,
        callback: $$v => {
          this.itemsType = $$v;
        }
      }
    }, [this.itemSelectTypes.map(k => h("a-select-option", {
      "attrs": {
        "value": k
      }
    }, [k]))])])])]);
  }
  onCancel() {
    this.$emit('msg', {});
  }
};
SchemaBaseView = __decorate([Component({
  name: 'SchemaBaseView'
})], SchemaBaseView);
export default SchemaBaseView;
//# sourceMappingURL=SchemaBaseView.js.map
